import { ref, onMounted } from 'vue'

const isDark = ref(false)

export function useTheme() {
    const toggleTheme = () => {
        isDark.value = !isDark.value
        applyTheme()
    }

    const applyTheme = () => {
        const root = document.documentElement
        if (isDark.value) {
            root.classList.add('dark')
            localStorage.setItem('theme', 'dark')
        } else {
            root.classList.remove('dark')
            localStorage.setItem('theme', 'light')
        }
    }

    onMounted(() => {
        const savedTheme = localStorage.getItem('theme')
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

        if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
            isDark.value = true
        }
        applyTheme()
    })

    return { isDark, toggleTheme }
}